import {
  GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_LOADING,
  GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_SUCCESS,
  GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_FAILURE,
} from "redux/types";

const initialState = {
  getExternalProjectsSubCategoriesLoading: false,
  externalProjectsSubCategoriesData: null,
  errors: null,
};

export const getExternalProjectsSubCategoriesReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_LOADING:
      return {
        ...state,
        getExternalProjectsSubCategoriesLoading: action.payload,
      };
    case GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_SUCCESS:
      return { ...state, externalProjectsSubCategoriesData: action.payload };
    case GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
